
import { Observable ,  of } from 'rxjs';
import { ContactsItemModel } from '../../../Shared/components/Contacts/contacts-data-item.model';

export class ContactsDataSource {
    public dataSource: ContactsItemModel[] = [];

    public all(): Observable<any> {
        return of(this.dataSource);
    }

    public search(): Observable<any> {
        return of(this.dataSource);
    }

    public addContact(item: ContactsItemModel): void {
        this.dataSource.push(item);
    }

    public updateContact(item: ContactsItemModel, index: number): void {
        this.dataSource[index] = item;
    }

    public deleteContact(item: ContactsItemModel): void {
        this.dataSource.splice(this.dataSource.indexOf(item), 1);
    }
}
